import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/index.vue'
Vue.use(Router)

export default new Router({
  mode: 'history', 
  routes: [{
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: Index,
      children: [{
        path: 'scIntro',
        component: () => import('../views/indexNavPage/scIntro.vue')
      }]
    },
    {
      path: '/scNewsDetail',
      component: () => import('../views/details/scNewsDetail.vue')
    },
    {
      path: '/synews',
      component: () => import('../views/details/synews.vue')
    },
    {
      path: '/specDyDetail',
      component: () => import('../views/details/specDyDetail.vue')
    },
    {
    path: '/specDyDetail_02',
    component: () => import('../views/details/specDyDetail_02.vue')
  },
    //顶部导航路由
    {
      path: '/scAbout',
      component: () => import('../views/details/indeNavTabDetail/scAbout.vue')
    },
    {
      path: '/techPrj',
      component: () => import('../views/details/indeNavTabDetail/techPrj.vue')
    },
    {
      path: '/dangjian',
      component: () => import('../views/details/indeNavTabDetail/dangjian.vue')
    },
    {
      path: '/zhaosheng',
      component: () => import('../views/details/indeNavTabDetail/zhaosheng.vue')
    },
    {
      path: '/techCol',
      component: () => import('../views/details/indeNavTabDetail/techCol.vue')
    },
    {
      path: '/empExis',
      component: () => import('../views/details/indeNavTabDetail/empExis.vue'),
      children: [{
          path: 'empExis',
          component: () => import('../views/details/indeNavTabDetail/empExis.vue'),
        },
        {
          path: 'peiXunMsg',
          component: () => import('../views/details/indeNavTabDetail/empExisComp/peiXunMsg.vue')
        }
      ]
    },
    {
      path: '/scTeam',
      component: () => import('../views/details/indeNavTabDetail/scTeam.vue')
    },
    {
      path: '/scIntro',
      component: () => import('../views/indexNavPage/scIntro.vue')
    },
    {
      path: '/tabDetails',
      component: () => import('../views/details/tabDetails.vue')
    },
    {
      path: '/more',
      component: () => import('../views/details/menuNav/more.vue')
    },
    {
      path: '/newsDetail',
      component: () => import('../views/details/newsDetail.vue')
    },
    {
      path: '/special',
      component: () => import('../views/details/newsDetail.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js